import { Component, Input, Output, EventEmitter, ElementRef, OnInit, Renderer2, AfterViewInit, OnChanges, Inject } from '@angular/core';

import { AbsKeymapService } from '../abs-utilities/abs-keymap.service';

@Component({
  selector: 'abs-switch',
  template: `<div class="btn-switch" [ngStyle]="{width: width + 'px'}" [ngClass]="{'focused': isFocused}" (click)="toggleButton()" (keydown)="handleKeys($event)">
	<fieldset [attr.role]="radiogroup" [ngClass]="{'disabled': isDisabled}">
		<div>
			<input type="radio" [(ngModel)]="modelValue" id="{{switchId}}-1" value="true" class="radio" [attr.name]="switchId + '--name'" [disabled]="isDisabled" (focus)="addFocus()" (blur)="removeFocus()">
			<label class="hidden-spoken" for="{{switchId}}-1">{{options?.on}}</label>
		</div>
		<div>
			<input type="radio" [(ngModel)]="modelValue" id="{{switchId}}-2"  value="false" class="radio" [attr.name]="switchId + '--name'" [disabled]="isDisabled" (focus)="addFocus()" (blur)="removeFocus()">
			<label class="hidden-spoken" for="{{switchId}}-2">{{options?.off}}</label>
		</div>
	</fieldset>
	<div class="switch-overlay" [attr.aria-hidden]="true" [attr.role]="button">
		<span class="btn-slider-on">{{options?.on}}</span>
		<span class="switch-handle"></span>
		<span class="btn-slider-off">{{options?.off}}</span>
	</div>
</div>`,
  styles: [`.btn-swtich-label{display:-webkit-box;display:-ms-flexbox;display:flex}.btn-swtich-label>span{-webkit-box-flex:1;-ms-flex:1;flex:1}.btn-switch{background-color:#fff;border:1px solid #d2d2d2;border-radius:16px;-webkit-box-shadow:0 4px 5px -5px rgba(0,0,0,.15) inset,0 5px 5px -5px rgba(0,0,0,.15);box-shadow:0 4px 5px -5px rgba(0,0,0,.15) inset,0 5px 5px -5px rgba(0,0,0,.15);height:32px;overflow:hidden;position:relative;width:80px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.btn-switch input[type=button],.btn-switch input[type=radio]{left:0;margin:0;opacity:0;position:absolute;top:0;-webkit-transition:none;transition:none}.btn-switch fieldset+.switch-overlay{left:0;-webkit-transition:all .3s linear 0s;transition:all .3s linear 0s}.btn-switch fieldset+.switch-overlay .switch-handle.onstate{background-color:#007a3e;background:-webkit-gradient(linear,left top,left bottom,from(#008744),to(#007a3e));background:linear-gradient(to bottom,#008744 0,#007a3e 100%);-webkit-transition:background-color .3s linear 0s;transition:background-color .3s linear 0s;border:1px solid transparent}.btn-switch fieldset+.switch-overlay{-webkit-transition:all .3s linear 0s;transition:all .3s linear 0s}.btn-switch fieldset+.switch-overlay .switch-handle{background-color:#f2f2f2;background:-webkit-gradient(linear,left top,left bottom,from(#fcfcfc),to(#f2f2f2));background:linear-gradient(to bottom,#fcfcfc 0,#f2f2f2 100%);-webkit-transition:background-color .3s linear 0s;transition:background-color .3s linear 0s;border:1px solid #d2d2d2}.btn-switch fieldset[disabled]+.switch-overlay{left:0;width:100%!important;background-color:#d2d2d2;color:#959595;cursor:not-allowed!important}.btn-switch fieldset[disabled]+.switch-overlay .btn-slider-on,.btn-switch fieldset[disabled]+.switch-overlay .switch-handle{display:none}.btn-switch fieldset[disabled]+.switch-overlay .btn-slider-off{left:0;text-align:center;padding:0}.btn-switch fieldset[disabled]:checked+.switch-overlay{left:0;width:100%!important;background-color:#fff}.btn-switch fieldset[disabled]:checked+.switch-overlay .btn-slider-off,.btn-switch fieldset[disabled]:checked+.switch-overlay .switch-handle{display:none}.btn-switch fieldset[disabled]:checked+.switch-overlay .btn-slider-on{display:block;text-align:center;padding:0;color:#007a3e!important;font-weight:700}.btn-switch fieldset[disabled]:checked+.btn-slider-on{display:block}.btn-switch fieldset[disabled]+.btn-slider-on+.switch-handle{width:100%;margin:0}.btn-switch fieldset[disabled]+.btn-slider-on+.switch-handle+.btn-slider-off{display:block}.switch-overlay{border-radius:16px;color:#000!important;font-size:1.6rem;height:32px;left:0;position:absolute;top:-1px;width:100%;overflow:hidden}.btn-slider-on{left:-22px;text-align:left;padding-left:0;display:inline-block;font-family:font-regular;height:32px;line-height:32px;position:absolute;top:1px;width:80px}.btn-slider-off{display:inline-block;font-family:font-regular;height:32px;line-height:32px;position:absolute;top:1px;width:80px;right:0;text-align:right;padding-left:50%;padding-right:0}.switch-handle{border-radius:50%;display:inline-block;height:26px;left:50px;position:absolute;top:3px;width:26px}.btn-switch.focused{outline:#000 dotted 1px;outline-offset:5px}`],
})
export class AbsSwitchComponent implements OnInit, AfterViewInit, OnChanges {

	@Input('disabled') isDisabled: boolean = false;
	@Input('id') switchId: string;
	@Input('ngModel') modelValue: boolean = false;
	@Output('ngModelChange') modelValueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output('change') changeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() options:{on, off};

	private width: number = 0;
	private leftOffset: number = 0;
	private rightOffset: number = 0;
	private isFocused: boolean = false;
	private switchElements;

	constructor(
		@Inject(ElementRef) private elementRef: ElementRef, 
		@Inject(Renderer2) private renderer: Renderer2, 
		@Inject(AbsKeymapService) private keymapService: AbsKeymapService) {}

	ngOnInit() {
		const element:Element = this.elementRef.nativeElement;

		if (this.options === undefined) {
			this.options = {
				'on': 'On',
				'off': 'Off'
			};
		}

		this.switchElements = element.querySelectorAll('span');

		const offset = Math.max(this.options.on.length, this.options.off.length);
		this.width = (offset * 10) + 52;
		this.leftOffset = ((300) / this.width);
		this.rightOffset = 100 - ((28*100) / this.width);
	}

	ngOnChanges(changes): void {
		const element:Element = this.elementRef.nativeElement;
		this.switchElements = element.querySelectorAll('span');
		this.updateStyles();
	}

	ngAfterViewInit(): void {
		const element:Element = this.elementRef.nativeElement;
		setTimeout(() => {
			const radioButtons = element.querySelectorAll('input');
			if (this.modelValue) {
				element.querySelector('#' + this.switchId + '-1')['checked'] = true;
			} else {
				element.querySelector('#' + this.switchId + '-2')['checked'] = true;
			}
			this.updateStyles();
		}, 10);
	}

	addFocus():void {
		this.isFocused = true;
	}

	removeFocus():void {
		this.isFocused = false;
	}

	toggleButton(): void {
		this.modelValue = !this.modelValue;
		this.modelValueChange.emit(this.modelValue);
		this.changeChange.emit(this.modelValue);

		this.updateStyles();
	}

	handleKeys(event): void {
		const keyCode = event.keyCode;
		if (keyCode === this.keymapService.KEY.LEFT || keyCode === this.keymapService.KEY.UP ||
			keyCode === this.keymapService.KEY.RIGHT || keyCode === this.keymapService.KEY.DOWN) {
			this.toggleButton();
		}
	}

	updateStyles():void {
		if (this.modelValue) {
			this.renderer.setStyle(this.switchElements[0], 'left', '10%');
			this.renderer.setStyle(this.switchElements[1], 'left', this.rightOffset + '%');
			this.renderer.setStyle(this.switchElements[1], 'transition', 'all 0.3s linear 0s');
			this.renderer.addClass(this.switchElements[1], 'onstate');
			this.renderer.setStyle(this.switchElements[2], 'right', '100%');
		} else {
			this.renderer.setStyle(this.switchElements[0], 'left', '100%');
			this.renderer.setStyle(this.switchElements[1], 'left', this.leftOffset + '%');
			this.renderer.setStyle(this.switchElements[1], 'transition', 'all 0.3s linear 0s');
			this.renderer.removeClass(this.switchElements[1], 'onstate');
			this.renderer.setStyle(this.switchElements[2], 'right', '10%');
		}
	}
};